<template>
  <div>
    <v-row>
      <v-col>
        <v-dialog v-model="dialog" persistent max-width="30cm">
          <v-card style="overflow-y: auto !important">
            <v-card-title class="header">
              <span> Document Preview </span>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">
                Close
              </v-btn>

              <v-btn color="blue darken-1" text v-print="'#page'"
                ><v-icon>mdi-print</v-icon> Print</v-btn
              >
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="background-color: #F6F6F6; padding-top: 80px">
              <v-container>
                <div class="page" id="page">
                  
                <!-- <div style="font-family: Avenir, sans-serif" id="page" class="test">
                  <vue-document-editor :content.sync="content" />
                </div> -->
                  <v-row no-gutters>
                    <v-col cols="3">
                      <div style="text-align:center">
                        <img
                          src="../../../assets/dole1.png"
                          height="100"
                          class="mt-4"
                        />
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div style="text-align: center;">
                        <h5>Republic of the Philippines</h5>
                        <h4>DEPARTMENT OF LABOR AND EMPLOYMENT</h4>
                        <h5>Region 9</h5>
                        <div>
                          Cortez Building, Evangelista Street,<br />Brgy. Sta.
                          Catalina, Zamboanga City
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="3">
                      <div style="text-align:center">
                        <img
                          src="../../../assets/dole2.jpg"
                          height="80"
                          class="mt-4"
                        />
                      </div>
                    </v-col>
                  </v-row>
                  <table
                    style="width: 100%;margin-top: 20px"
                    class="custom-table"
                  >
                    <tr>
                      <td colspan="2">
                        Document Tracer Number: {{ document.transaction_id }}
                      </td>
                      <td colspan="2">Sender: {{ document.sender }}</td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <b>SUBJECT: </b>{{ document.subject }}
                      </td>
                    </tr>
                    <tr>
                      <td><b>Date and Time Received</b></td>
                      <td><b>From</b></td>
                      <td><b>To</b></td>
                      <td><b>Action Required/Remarks</b></td>
                    </tr>
                    <tbody v-for="(item, index) in actions" :key="index">
                      <tr>
                        <td>{{ formatTime(document.createdAt) }}</td>
                        <td>Records</td>
                        <td>
                          <div
                            v-for="(i, index) in getListOfOffices(item)"
                            :key="index"
                          >
                            <span>{{ i.office }} - {{ i.name }}</span>
                          </div>
                        </td>
                        <td>
                          <div
                            v-for="(z, index) in getListOfActions(item)"
                            :key="index"
                          >
                            <span>{{ z }}</span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="4">
                          <div
                            v-for="(t, index) in getListOfInstructions(item)"
                            :key="index"
                          >
                            <span
                              ><b>Instructions for {{ t.office }}:</b></span
                            >
                            <br />
                            <span
                              v-dompurify-html="
                                t.instructions
                                  ? getStringfromHtml(t.instructions)
                                  : `No instructions included`
                              "
                            >
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <v-row>
                    <v-col style="text-align:center">
                      <QRCODE />
                    </v-col>
                    <v-col style="text-align:center">
                      <div class="stamp">
                        <p style="font-size: 10px; line-height: 12px; margin-bottom: 0px"
                          >DEPARTMENT OF LABOR<br />AND EMPLOYMENT<br />RECEIVED<br
                        /></p>
                        <v-row>
                          <v-col
                            cols="3"
                            style="padding-top: 0; padding-bottom: 0; margin-top: 0px; margin-bottom: 0; height: 25px"
                          >
                            <v-subheader style="font-size: 8px; height: 22px"><b>Date</b></v-subheader>
                          </v-col>
                          <v-col
                            cols="9"
                            style="padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; padding-right: 30px"
                          >
                            <v-menu
                              ref="menu1"
                              v-model="menu1"
                              :close-on-content-click="false"
                              transition="scale-transition"
                              offset-y
                              max-width="290px"
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  style="padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; font-size: 12px;"
                                  v-model="dateFormatted"
                                  hint="MM/DD/YYYY format"
                                  persistent-hint
                                  v-bind="attrs"
                                  @blur="date = parseDate(dateFormatted)"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="date"
                                no-title
                                @input="menu1 = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="3"
                            style="padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; height: 25px"
                          >
                            <v-subheader style="font-size: 8px; height: 22px"><b>Initial</b></v-subheader>
                          </v-col>
                          <v-col
                            cols="9"
                            style="padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; padding-right: 30px"
                          >
                            <v-text-field
                              style="padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; font-size: 12px;"
                              :value="setInitial"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="3"
                            style="padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; height: 25px"
                          >
                            <v-subheader style="font-size: 8px; height: 22px"><b>Time</b></v-subheader>
                          </v-col>
                          <v-col
                            cols="9"
                            style="padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; padding-right: 30px"
                          >
                            <v-text-field
                              v-model="time"
                              style="padding-top: 0; padding-bottom: 0; margin-top: 0; margin-bottom: 0; font-size: 12px;"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <p style="font-size: 7px; margin-bottom: 0px"
                          >REGION 9, ZAMBOANGA CITY</p
                        >
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-container>
            </v-card-text>
            <v-divider></v-divider>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import QRCODE from '../pagecontent/QRCODE.vue';
// import VueDocumentEditor from 'vue-document-editor'
import _ from 'lodash';
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
  name: 'DocumentTypeModal',
  props: {
    dialog: Boolean,
    document: Object,
    addedReceivers: Array,
    allsubroutes: Array,
  },
  components: {
    QRCODE,
    // VueDocumentEditor 
  },
  data() {
    return {
      content: null,
      subroutes: null,
      actions: [],
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateFormatted: moment().format('L'),
      menu1: false,
      menu2: false,
      time: moment().format('LT'),
      initial: null,
    };
  },
  watch: {
    dialog() {
      let route_id = null;
      Object.keys(this.document.routes).forEach(
        (key) => (route_id = this.document.routes[key].id)
      );
      this.subroutes = null;
      this.actions = [];
      var test = this.allsubroutes.filter(
        (subroute) => subroute.route_id === route_id
      );
      this.subroutes = _.groupBy(test, 'action_id');
      Object.keys(this.subroutes).forEach((key) => {
        this.actions.push(this.subroutes[key]);
      });

      // var testt = document.getElementById('document_slip_content').innerHTML
      // this.content = [testt]
    },
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  computed: {
    ...mapGetters(['getAllSubRoutes', 'loggedInUserName']),
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
    setInitial() {
      let str = this.getAbbreviation(this.loggedInUserName);
      str = str.replace(/.{1}/g, '$&.');
      return str;
    },
  },
  methods: {
    close() {
      this.$emit('closeDialog', false);
    },
    getAbbreviation(text) {
      if (typeof text != 'string' || !text) {
        return '';
      }
      const acronym = text
        .match(/[\p{Alpha}\p{Nd}]+/gu)
        .reduce(
          (previous, next) =>
            previous +
            (+next === 0 || parseInt(next) ? parseInt(next) : next[0] || ''),
          ''
        )
        .toUpperCase();
      return acronym;
    },
    print() {
      //add code print here
      console.log('printing');
    },
    formatTime(time) {
      return moment(time).format('LLL');
    },
    getListOfOffices(item) {
      let address = [];
      item.forEach((i) => {
        this.addedReceivers.forEach((receivers) => {
          if (i.user_id === receivers.user.id)
            address.push({
              office: this.getAbbreviation(receivers.user.offices[0].name),
              name: receivers.user.name,
            });
        });
      });
      return address;
    },
    getListOfActions(item) {
      let actions = [];
      item.forEach((i) => {
        actions.push(i.action.name);
      });
      let uniqueChars = [...new Set(actions)];
      return uniqueChars;
    },
    getListOfInstructions(item) {
      let instructions = [];
      item.forEach((i) => {
        this.addedReceivers.forEach((receivers) => {
          if (i.user_id === receivers.user.id)
            instructions.push({
              office: this.getAbbreviation(receivers.user.offices[0].name),
              instructions: i.instructions,
            });
        });
      });
      return instructions;
    },
    getStringfromHtml(html) {
      var txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },
  },
};
</script>

<style scoped>
.custom-table {
  table-layout: fixed;
  border-collapse: collapse;
  border: 0px solid;
}
/deep/ .v-text-field input{
      padding-top: 0px;
      padding-bottom: 0px;
}
.custom-table td {
  width: 33%;
  border: 0px solid;
  padding: 8px;
}
.test {
  display: none;
}
.page {
  width: 21cm;
  min-height: 29.7cm;
  padding: 1cm;
  padding-top: 1cm;
  padding-bottom: 1cm;
  margin: 1cm auto;
  border: 0px #d3d3d3 solid;
  border-radius: 5px;
  background: white;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
.header {
  width: 30cm;
  position: fixed;
  background: #ffffff;
  padding: 16px 24 16px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.12);
  z-index: 1;
}
/* .page-content {
    padding: 2cm;
    margin: 1cm auto;
    background: white;
} */
.stamp {
  color: #555;
  font-size: 20px;
  font-weight: 700;
  width: 40%;
  height: 68%;
  border: 0.25rem solid #555;
  display: inline-block;
  padding: 0.25rem 0.10rem;
  text-transform: uppercase;
  font-family: 'Courier';
  -webkit-mask-image: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/8399/grunge.png');
  -webkit-mask-size: 944px 604px;
  mix-blend-mode: multiply;
}
@media print {
  .page {
    size: A4;
    margin: 0 auto;
    padding: 0;
    border: 0px #d3d3d3 solid;
    box-shadow: 0 0 0 rgba(0, 0, 0, 0);
  }
  table { page-break-after:auto }
    tr    { page-break-inside:avoid; page-break-after:auto }
    td    { page-break-inside:avoid; page-break-after:auto }
    thead { display:table-header-group }
    tfoot { display:table-footer-group }
}
@page {
  size: A4;
  margin:1cm 0cm
}
</style>
